import {
  BorderColor,
  DeliveryDiningTwoTone,
  MenuBookTwoTone,
  PanToolTwoTone,
} from "@mui/icons-material";
import {
  Alert,
  Avatar,
  Box,
  Container,
  Skeleton,
  Snackbar,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import TableCallDialog from "dialogs/TableCallDialog";
import { Colors } from "helpers/Consts";
import { useState, SyntheticEvent } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useQueryPlace } from "services/api/queries/useQueryPlace";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}

function Landing({shoppingBagQuery}: Props) {
  const [openEditTableNumberDialog, setOpenEditTableNumberDialog] =
    useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  

  // GET place_id from URL
  const [searchParams] = useSearchParams();
  const { search} = useLocation()
  const placeId = searchParams.get("place_id");
  const table = searchParams.get("table");

  const [disabledChamarGarcom] =
    useState<boolean>(() => {
      return table === null
    });

  const handleNewTableCall = () => {
    setOpenEditTableNumberDialog(true);
  };
  const handleCloseEditTableNumberDialog = () => {
    setOpenEditTableNumberDialog(false);
  };
  const handleCloseSnackBar = (
    event?: SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  const handleSnackBar = () => {
    setOpenSnackBar(true);
  }
  // Query and Redux to Places
  const apiPlace = useQueryPlace(Number(placeId) ? Number(placeId) : 445057); // do ReactQuery and store in redux
  return (
    <>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          sx={{ width: "100%" }}
        >
          O garçom foi chamado.
        </Alert>
      </Snackbar>
      <TableCallDialog
        handleClose={handleCloseEditTableNumberDialog}
        open={openEditTableNumberDialog}
        openSnackBarTableCall={handleSnackBar}
        shoppingBagQuery={shoppingBagQuery}
      />
      <Container maxWidth="lg" sx={{
        marginTop: { md: 8 }
      }}>
        <Box>
          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {apiPlace?.data?.data ? (
              <Avatar
                variant="rounded"
                alt={apiPlace?.data?.data.name}
                src={apiPlace?.data?.data.logo_image}
                sx={{
                  width: { xs: "130px", sm: "165px" },
                  height: { xs: "130px", sm: "165px" },
                }}
              />
            ) : (
              <Skeleton
                variant="rectangular"
                sx={{
                  width: { xs: "130px", sm: "165px" },
                  height: { xs: "130px", sm: "165px" },
                }}
                animation="wave"
              />
            )}
            {apiPlace?.data?.data ? (
              <>
                <Typography
                  variant="h5"
                  color="black"
                  sx={{
                    fontWeight: { xs: "700", sm: "700" },
                    fontSize: { xs: "15px", sm: "20px" },
                    marginTop: "15px",
                  }}
                >
                  {apiPlace?.data?.data.name}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography
                  color={Colors.baseTextColor}
                  sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                >
                  {/* {apiPlace?.data?.data.delivery_min_time} ~{" "}
                  {apiPlace?.data?.data.delivery_max_time} min */}
                  Selecione uma das opções abaixo:
                </Typography>
              </>
            ) : (
              <Skeleton
                variant="text"
                sx={{ width: "50%", marginTop: "15px" }}
                animation="wave"
              />
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            {apiPlace?.data?.data ? (
              <>
                <Chip
                  icon={<MenuBookTwoTone />}
                  label="Ver Cardápio"
                  color="primary"
                  variant="outlined"
                  component={Link}
                  to={`/cardapio${search}`}
                  clickable
                  sx={{
                    margin: "12px 0px",
                    width: "60%",
                    height: "40px",
                  }}
                />
                <Chip
                  color="primary"
                  variant="outlined"
                  icon={table !== null || apiPlace?.data?.data?.only_withdraw === true ? <BorderColor /> : <DeliveryDiningTwoTone />}
                  component={Link}
                  to={`/delivery${search}`}
                  clickable
                  sx={{
                    margin: "12px 0px",
                    width: "60%",
                    height: "40px",
                  }}
                  // label="Delivery"
                  label={table !== null || apiPlace?.data?.data?.only_withdraw === true ? 'Fazer Pedido' : "Delivery"}
                />
                {!disabledChamarGarcom ?   (<Chip
                  color="primary"
                  variant="outlined"
                  icon={<PanToolTwoTone />}
                  onClick={handleNewTableCall}
                  clickable
                  hidden={disabledChamarGarcom}
                  disabled={disabledChamarGarcom}
                  sx={{
                    margin: "12px 0px",
                    width: "60%",
                    height: "40px",
                  }}
                  label="Chamar Garçom"
                />) : null }
              </>
            ) : (
              <>
                <Skeleton
                  variant="text"
                  sx={{ width: "50%", marginTop: "15px" }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  sx={{ width: "50%", marginTop: "15px" }}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  sx={{ width: "50%", marginTop: "15px" }}
                  animation="wave"
                />
              </>
            )}
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default Landing;
